'use client';
import { getRecaptchaToken } from './recaptcha';

const LEADS_PROXY_ENDPOINT = '/backend/leads';

export const submitLeadFormData = async (formData: FormData) => {
  const token = await getRecaptchaToken();
  if (token) {
    formData.append('recaptchaToken', token);
  }

  return fetch(LEADS_PROXY_ENDPOINT, {
    method: 'POST',
    body: formData,
  });
};

export const submitLeadJson = async (payload: Record<string, unknown>) => {
  const token = await getRecaptchaToken();
  const body = token ? { ...payload, recaptchaToken: token } : payload;

  return fetch(LEADS_PROXY_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};
